var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "file mg mg--b-5" }, [
    _c("p", { staticClass: "mg mg--b-2 text-small-bold gray" }, [
      _vm._v(_vm._s(_vm.titleInput)),
    ]),
    _c("div", { staticClass: "grid" }, [
      _c(
        "ul",
        { staticClass: "grid" },
        [
          _vm._l(_vm.imageList, function (image) {
            return _c("li", { staticClass: "containerThumbnail mg mg--r-2" }, [
              _c("img", { attrs: { src: image.thumbnailURL } }),
            ])
          }),
          _vm.spinner
            ? _c(
                "div",
                { staticClass: "content-spinner" },
                [
                  _c("ma-spinner", {
                    staticClass: "spinner",
                    attrs: { size: "small" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "containerFileImg" },
            [
              _c("svgicon", {
                attrs: {
                  name: "camera-create",
                  color: "#7CAACF",
                  width: "24",
                  height: "24",
                },
              }),
              _c("input", {
                staticClass: "file text-medium-light",
                attrs: {
                  type: "file",
                  name: _vm.name,
                  accept: ".jpg, .jpeg, .png",
                  multiple: "",
                },
                on: { change: _vm.handleChangeInput },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ]),
    _c("p", { staticClass: "blueDark text-small mg mg--t-2" }, [
      _vm._v(_vm._s(_vm.$t("damageDetails.errorPhoto"))),
    ]),
    _c(
      "p",
      {
        staticClass: "errorMsg text-small",
        class: { errorVisible: _vm.errorInput },
      },
      [_vm._v(_vm._s(_vm.$t("damageDetails.errorPhoto")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }